import { Component, ElementRef, Inject, Input } from '@angular/core';
import { ApplicationFormService } from '../application-form/application-form.service';
import { LoggerService } from '@app/blocks/logger/services/logger.service';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject, Observable, Subject, firstValueFrom, of, takeUntil } from 'rxjs';
import { ReferencesService } from './references.service';
import { DataService } from '@app/core/services/data.service';
import { formatFormErrors } from '@app/shared/formly/form-config';
import { ApplicationFormDataService } from '../application-form/application-form-data.service';
import { SlideCommonService } from '../common/slide-common.service';
import { AsyncPipe, CommonModule, NgFor, NgIf } from '@angular/common';
import { ConnectSlideComponent } from '@app/blocks/ui/slide/slide.component';
import { FormlyModule } from '@ngx-formly/core';
import { SpinnerComponent } from '@app/shared/components/spinner/spinner.component';
import { WINDOW, WINDOW_PROVIDERS } from '@app/shared/services/window/window.service';

@Component({
    selector: 'app-references',
    templateUrl: './references.component.html',
    providers: [
        ReferencesService,
        WINDOW_PROVIDERS
    ],
    imports: [
        CommonModule,
        ConnectSlideComponent,
        SpinnerComponent,
        FormlyModule,
        AsyncPipe,
        NgIf,
        NgFor
    ]
})
export class ReferencesComponent {
    @Input() slideNumber: string | undefined;
    @Input() finalSlide = false;
    currentSlide = 'references';
    active = this.afs.getActive();
    showSubmit = false;
    showError = false;
    showFormErrors = false; //error summary
    errorMessage = "";
    errors: any = [];
    isDisabled = false;
    submitting = false;

    form: FormGroup = new FormGroup(
        {}
    );
    fields: BehaviorSubject<any> = new BehaviorSubject([]);
    model: any = this.afs.getReferencesModel();

    constructor(
        private afs: ApplicationFormService,
        private logger: LoggerService,
        private el: ElementRef,
        private referencesService: ReferencesService,
        private dataService: DataService,
        private applicationFormDataService: ApplicationFormDataService,
        private slideCommon: SlideCommonService,
        @Inject(WINDOW) private window: Window,
    ) { }

    private destroy$ = new Subject<void>();

    subscription = this.afs.subscribeReferencesModel((data: any) => {
        this.model = data;

        const observables: Observable<any>[] = [
            of(this.referencesService.fetchForm(this.model)),
            // of(this.afs.getFormState()),
        ]

        this.dataService.ready(observables).pipe(takeUntil(this.destroy$)).subscribe(
            {
                next: ([ form ]) => {
                    this.fields.next(form);

                    this.showSubmit = true;
                    console.log(this.model)
                },
                error: () => {
                    console.log('"ready" function failed');
                }
            }
        );
    });

    get formState() {
        return this.afs.formState;
    }

    onInit() {
        console.log('references');
        this.afs.getActive();
    }

    onBack() {
        this.isDisabled = false;
        this.submitting = false;
        this.afs.goBack('references');
        this.slideCommon.scroll(this.active.active);
    }

    onSubmit() {
        this.logger.info('references submit clicked');
        this.form.markAllAsTouched();

        if (this.form.valid) {
            console.log("VALID");
            this.errors = [];
            this.showFormErrors = false;

            this.isDisabled = true;
            this.submitting = true;

            firstValueFrom(this.applicationFormDataService.postReferences(this.model)).then((response: any) => {
                console.log('additional references post success ' + response.status);

                this.slideCommon.save(this.form, this.currentSlide, this.formState, this.active);

                this.isDisabled = false;
                this.submitting = false;
            }).catch((error) => {
                this.isDisabled = false;
                this.submitting = false;
                this.logger.error(error);
            });
        }
        else {
            console.log("INVALID", this.form.errors)
            const renderTime = 500;
            const revealTime = renderTime + 250;

            setTimeout(() => {
                this.errors = formatFormErrors(this.el, this.form);
                this.showFormErrors = true;
            }, renderTime);

            setTimeout(() => {
                this.scrollToId('references-error-summary');
            }, revealTime);
        }
    }

    scrollToId(id: string) {
        this.slideCommon.scrollToId(id, this.el, this.window);
    }
}
